module.exports = __webpack_public_path__ + "static/media/Powered_By_Cloud.27d0fc55.svg";